import Sideview from './Sideview'

export default Sideview
